export default __webpack_public_path__ + "static/media/69.10d4ed4c.jpg";